var _circle, _circle2, _circle3, _rect, _polygon, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFederalHousingLoan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "#ffffff",
    stroke: "#2d5016",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "#2d5016"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "#ffffff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 40,
    width: 30,
    height: 25,
    fill: "#2d5016"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "35,40 50,25 65,40",
    fill: "#2d5016"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 45,
    width: 8,
    height: 12,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 45,
    width: 8,
    height: 8,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 57,
    width: 8,
    height: 8,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 47,
    width: 4,
    height: 4,
    fill: "#2d5016"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 47,
    width: 4,
    height: 4,
    fill: "#2d5016"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 59,
    width: 4,
    height: 4,
    fill: "#2d5016"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 6,
    fill: "#2d5016",
    fontWeight: "bold"
  }, "FGHLB")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFederalHousingLoan);
export default __webpack_public_path__ + "static/media/federal-housing-loan.26d34de2b8ed53af287cf29745540255.svg";
export { ForwardRef as ReactComponent };